var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 9,
    viewBox: "0 0 19 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#115E67",
    d: "M19 4.494c0 .496-.466.898-1.04.898H3.589L5.98 7.448c.408.362.399.941-.02 1.293-.42.352-1.09.344-1.498-.018L.302 5.131c-.095-.085-.169-.186-.219-.296-.11-.218-.11-.465 0-.683.05-.11.124-.21.219-.296L4.462.264c.409-.352 1.07-.352 1.478 0 .408.352.408.923 0 1.275L3.589 3.596h14.37c.575 0 1.041.402 1.041.898z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.af0e7a852a3e4ad3338f31d646b3e7c5.svg";
export { ForwardRef as ReactComponent };